module.exports = __webpack_public_path__ + "static/media/facebook.9079c5fa.svg";